module.exports = __webpack_public_path__ + "img/13.e8bf5cc0.jpg";